import { render, staticRenderFns } from "./DashboardTransactions.vue?vue&type=template&id=9732d2f8&"
import script from "./DashboardTransactions.vue?vue&type=script&lang=js&"
export * from "./DashboardTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports